import { render, staticRenderFns } from "./gkkp-settings.vue?vue&type=template&id=abe0e6f8&scoped=true&"
import script from "./gkkp-settings.vue?vue&type=script&lang=ts&"
export * from "./gkkp-settings.vue?vue&type=script&lang=ts&"
import style0 from "./gkkp-settings.vue?vue&type=style&index=0&id=abe0e6f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe0e6f8",
  null
  
)

export default component.exports